import _find from 'lodash/find';
import _findKey from 'lodash/findKey';
import _includes from 'lodash/includes';
import _orderBy from 'lodash/orderBy';
import _replace from 'lodash/replace';
import _size from 'lodash/size';
import _toUpper from 'lodash/toUpper';
// Models
import mScenario from './scenario';
// Custom
import { formatPhoneNumber, findInList } from '../utils/Tools';

/**
* Lists
*/
const accessWayTypesList = [
  {
    key: 'phone',
    value: 'phone',
    labelId: 'accessway.type.phone',
    icon: 'cAwTypePhone',
    pattern: /[^\d]/g,
  },
  {
    key: 'keypad_code',
    value: 'keypad_code',
    labelId: 'accessway.type.kcode',
    icon: 'cAwTypeKCode',
    pattern: /[^\d]/g,
  },
  {
    key: 'license_plate',
    value: 'license_plate',
    labelId: 'accessway.type.lplate',
    icon: 'cAwTypeLPlate',
    pattern: /[^a-zA-Z\d]/g,
  },
];

/**
* Utils
*/
const sortAccessWays = (accessWays, fields = ['type', 'desc'], dirs = ['asc', 'asc']) => (_orderBy(accessWays, fields, dirs));

const sanitizeAccessWayDesc = (desc, type) => {
  const typeObject = _find(accessWayTypesList, ['value', type]);
  if (!typeObject) {
    return desc;
  }
  return _toUpper(_replace(desc, typeObject.pattern, ''));
};

const accessWayType = (accessWay) => findInList(accessWayTypesList, 'value', accessWay, 'type');

const accessWayIcon = (accessWay) => {
  const type = accessWayType(accessWay);
  if (type) {
    return type.icon;
  }
  return null;
};

const accessWayDesc = (accessWay, countryCode) => {
  switch (accessWay.type) {
    case 'phone':
      return formatPhoneNumber(accessWay.desc, countryCode);
    case 'keypad_code':
    case 'license_plate':
    default:
      return accessWay.desc;
  }
};

const accessWayRightsQuantity = (accessWay) => _size(accessWay.rights);

const accessWayTypeFromTrigger = (trigger) => {
  if (!trigger) {
    return null;
  }
  const type = trigger.equipment ? trigger.equipment.type : trigger.type;
  return _findKey(mScenario.triggerTypesFromAccessWayTypeMap, (types) => (_includes(types, type)));
};

/**
* Model
*/
const accessWay = {
  // Name
  name: 'accessWay',

  // Sort elements
  sortElements: sortAccessWays,

  // Lists
  typesList: accessWayTypesList,

  // Utils
  sanitizeDesc: sanitizeAccessWayDesc,
  type: accessWayType,
  icon: accessWayIcon,
  desc: accessWayDesc,
  rightsQuantity: accessWayRightsQuantity,
  typeFromTrigger: accessWayTypeFromTrigger,
};

module.exports = accessWay;



// WEBPACK FOOTER //
// ./models/accessWay.js